import dynamic from 'next/dynamic';
const Layout = dynamic(() => import('../hoc/staticLayout'), { loading: () => <></>, ssr: true });
const PolicyContent = dynamic(() => import('../components/static/Policy'), { loading: () => <></>, ssr: true });
import { withRouter } from 'next/router';

function Policy(props) {
	const meta = {
		title: "Bayan Privacy Policy | Privacy Policy | Bayan",
		description: "As part of the services offered on the Bayan digital platform, we need to collect detailed information from you. In doing so, Bayan is committed to respecting the privacy of all its users.This Privacy Policy describes how Bayan, Inc. (“BAYAN”, “we”, “our”, “us”) collects, uses, and shares your personal information and applies to your use of any part of the BAYAN website (including bayanclaremont.org and bayanonline.org) as well as any mobile application, subscription or digital property that links to this Privacy Policy and all features, content, and other services that we own, control and make available through such online service location (collectively, the “Service”), regardless of how you access or use it.",
		route: "privacy-policy",
	}
	return (
		<>
			<Layout theme={props.theme} meta={meta}>
				<PolicyContent router={props.router} />
			</Layout>
		</>
	);
}

export default withRouter(Policy);
